<template>
    <div>
      <Head title="Routes" />
      <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-sky-400 hover:text-sky-600" href="/orders">Pedidos</Link>
      <span class="text-sky-400 font-medium">/</span> Detalles
    </h1>
      
      
      <div class="max-w-5xl bg-white rounded-md shadow overflow-hidden ">
        <div class="flex items-center justify-between p-4 mt-0 mb-5 bg-sky-600 ">
            <div class="bg-white  rounded-3xl ">
            <p class="text-1xl m-2">Tienda: <b>{{orderData[0].nameStore}}</b> </p>
            </div>
            <div class="bg-white  rounded-2xl ">
            <p class="text-1xl m-2">Encargado: <b>{{orderData[0].inCharge}}</b> </p>
            </div>
            <div class="bg-white  rounded-2xl ">
            <p class="text-1xl m-2">Fecha: <b>{{formatDate(orderDate)}}</b> </p>
            </div>
            <div class="bg-white  rounded-2xl ">
            <p class="text-1xl m-2 ">Total: <b>{{(orderTotal())}}</b> </p>
            </div>
            
        </div>
        <table class="w-full whitespace-nowrap">
          <tr class="text-left font-bold">          
            <th class="pb-4 pt-6 px-4">Id</th>
            <th class="pb-4 pt-6 px-2">Producto</th>
            <th class="pb-4 pt-6 px-2">Unidad</th>
            <th class="pb-4 pt-6 px-2">Precio</th>
            <th class="pb-4 pt-6 px-2">Cantidad</th>
            <th class="pb-4 pt-6 px-2">Subtotal</th>       
          </tr>
          <tr v-for="order in orderDetails" :key="order.id" class="hover:bg-gray-100 focus-within:bg-gray-100">          
            <td class="border-t pb-4 pt-6 px-4">
                {{ order.id }}                          <!--:href="`/routes/${route.id}/clients`"-->
            </td>
            <td class="border-t pb-4 pt-6 px-2">
                {{ order.name_product }}
            </td>
            <td class="border-t pb-4 pt-6 px-2">
                {{ order.product_unit }}
            </td>
            <td class="border-t pb-4 pt-6 px-2">
                ${{ order.price.toFixed(2) }}
            </td>
            <td class="border-t pb-4 pt-6 px-2">
                {{ order.amount }}
            </td>
            <td class="border-t pb-4 pt-6 px-2">
                ${{ (order.price * order.amount).toFixed(2)}}
            </td>
          </tr>
          <tr v-if="orderDetails.length === 0">
            <td class="px-6 py-4 border-t" colspan="14">No se encontraron los detalles.</td>
          </tr>
        </table>
      </div>
    </div>
  </template>
    
  <script>
  import { Head, Link } from '@inertiajs/inertia-vue3'
  import pickBy from 'lodash/pickBy'
  import Layout from '@/Shared/Layout'
  import throttle from 'lodash/throttle'
  import mapValues from 'lodash/mapValues'
  import Search from '@/Shared/Search'
  import DialogInput from '@/Shared/Dialog'
  import TextInput from '@/Shared/TextInput'
  import LoadingButton from '@/Shared/LoadingButton'
  import Icon from '@/Shared/Icon'   
  import Pagination from '@/Shared/Pagination'
  import InputFile from '@/Shared/InputFile'
  import TextareaInput from '@/Shared/TextareaInput'
  import SelectInput from '@/Shared/SelectInput'
  
  
  export default {
    components: {
      Head,
      Link,
      Search,
      DialogInput,
      LoadingButton,
      TextInput,
      Icon,
      Pagination,
      SelectInput,
      TextareaInput,
      InputFile,
  
    },
    layout: Layout,
    props: {    
      orderDetails: Object,
      orderData: Object,
      orderDate: String
 
    },
    remember: 'form',
    data() {
      return {     
        form: this.$inertia.form({
          code:'',
          description:'',
          estatus:'',
          //search: this.filters.search,
          //code: this.filters.code,
        }),
        dialogValue: '',
        showDialogInput: false,
        showDialogAddEmployee: false 
      }
    },
    watch: {
      form: {
        deep: true,
        handler: throttle(function () {
          this.$inertia.get('/orders', pickBy(this.form), { preserveState: true })
        }, 150),
      },
    },
    methods: {
      reset() {
      },
      goToOrder(orderId) {
      },  
      store() {
        
      },
      formatDate(originalDate){
        const formattedDate = new Date(originalDate);
        const opciones = {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          hour12: true
        };
        return formattedDate.toLocaleString('es-ES', opciones);

      },
      orderTotal(){
        
        var total= 0
        this.orderDetails.forEach(function(it){
          total += (it.amount * it.price)
        })
        return  `$${total.toFixed(2)}`
      },
      
  
      showDialog() {
        this.showDialogInput = true 
      },
      closeDialog() {
        this.showDialogInput = false 
      },   
    },
  }
  </script>  
  